import { inject, Injectable } from '@angular/core';

import { DialogRef, DialogService } from '@hglobal/fin-ui';

import { Transaction, Wallet } from '@kr/models';

import { CommentDialogComponent } from './comment-dialog.component';

@Injectable()
export class CommentDialog {
  readonly #dialog = inject(DialogService);

  open(transaction: Transaction, wallet: Wallet): DialogRef {
    return this.#dialog.open(CommentDialogComponent, { transaction, wallet });
  }
}
